// extracted by mini-css-extract-plugin
export var csatScore = "_nz-5";
export var header = "_nz-1";
export var panelWrapper = "_nz-2";
export var postPreview = "_nz-3";
export var rightContent = "_nz-0";
export var wrappingText = "_nz-4";